
import React from 'react';
import Layout from '@/components/layout/Layout';
import LocationHero from '@/components/locations/LocationHero';
import LocationFeatures from '@/components/locations/LocationFeatures';
import LocationTestimonials from '@/components/locations/LocationTestimonials';
import LocationCTA from '@/components/locations/LocationCTA';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';

const CopenhagenLocation = () => {
  const features = [
    {
      title: "Centralt i København",
      description: "Nem adgang til undervisning i forskellige områder af København, tæt på offentlig transport.",
      icon: "location"
    },
    {
      title: "Fleksible Tider",
      description: "Undervisning der passer ind i din travle hverdag i byen - også aften- og weekendtimer.",
      icon: "clock"
    },
    {
      title: "Skræddersyet Undervisning",
      description: "Personlig undervisning tilpasset dine musikalske mål og ambitioner.",
      icon: "music"
    },
    {
      title: "Konservatorieuddannet",
      description: "Undervisning med Oscar Gilbert, der er uddannet på Rytmisk Musikkonservatorium.",
      icon: "award"
    }
  ];

  const testimonials = [
    {
      name: "Louise Hansen",
      location: "Østerbro, København",
      text: "Oscar er en dygtig og engageret underviser. Han formår at tilpasse undervisningen præcis til mit niveau og mine interesser.",
      stars: 5
    },
    {
      name: "Anders Madsen",
      location: "Nørrebro, København",
      text: "Jeg har prøvet flere forskellige klaverlærere før, men ingen har kunnet forklare teknik og musikteori så forståeligt som Oscar.",
      stars: 5
    },
    {
      name: "Sofia Petersen",
      location: "Frederiksberg",
      text: "Oscar har en unik evne til at inspirere. Hans passion for musik er smittende, og det har virkelig hjulpet mig til at holde motivationen oppe.",
      stars: 5
    }
  ];

  return (
    <Layout>
      <LocationHero 
        title="Klaverundervisning i København"
        description="Professionel klaverundervisning i København med Oscar Gilbert. Fleksible tider og lokationer der passer ind i din travle hverdag i byen."
      />
      
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6">
                Klaverundervisning i København med <span className="text-piano-gold">Oscar Gilbert</span>
              </h2>
              <p className="text-lg text-gray-700 mb-6">
                Oscar Gilbert tilbyder professionel klaverundervisning forskellige steder i København, så du nemt kan passe det ind i din hverdag i byen.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                Undervisningen er tilgængelig i flere bydele, herunder Indre By, Østerbro, Nørrebro, Vesterbro og Frederiksberg, og foregår i Oscars øvelokale i Søborg (God busforbindelse med 6A) eller som hjemmeundervisning, hvor Oscar kommer til dig.
              </p>
              <p className="text-lg text-gray-700 mb-8">
                Med en personlig og struktureret tilgang til klaverundervisning får du en oplevelse, der er skræddersyet til dine behov og musikalske mål, uanset om du er nybegynder eller øvet pianist.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button asChild className="bg-piano-gold hover:bg-piano-gold/90 text-white">
                  <Link to="/kontakt">Book Gratis Prøvetime</Link>
                </Button>
                <Button asChild variant="outline">
                  <Link to="/undervisning">Se Undervisningstilbud</Link>
                </Button>
              </div>
            </div>
            <div className="flex justify-center">
              <div className="relative w-full max-w-lg">
                <div className="absolute -inset-1 bg-gradient-to-r from-piano-gold to-amber-500 rounded-lg blur-lg opacity-25"></div>
                <div className="relative bg-white p-6 rounded-lg shadow-xl">
                  <div className="bg-gray-100 rounded-lg p-8">
                    <h3 className="text-2xl font-serif font-bold mb-4 text-center">Områder i København</h3>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-center">
                        <span className="w-3 h-3 bg-piano-gold rounded-full mr-2"></span>
                        Indre By
                      </li>
                      <li className="flex items-center">
                        <span className="w-3 h-3 bg-piano-gold rounded-full mr-2"></span>
                        Østerbro
                      </li>
                      <li className="flex items-center">
                        <span className="w-3 h-3 bg-piano-gold rounded-full mr-2"></span>
                        Nørrebro
                      </li>
                      <li className="flex items-center">
                        <span className="w-3 h-3 bg-piano-gold rounded-full mr-2"></span>
                        Vesterbro
                      </li>
                      <li className="flex items-center">
                        <span className="w-3 h-3 bg-piano-gold rounded-full mr-2"></span>
                        Frederiksberg
                      </li>
                    </ul>
                    <p className="mt-4 text-gray-600 text-center">
                      Kontakt for specifik lokation i dit område
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <LocationFeatures features={features} />
      
      <LocationTestimonials testimonials={testimonials} locationName="København" />
      
      <LocationCTA locationName="København" />
    </Layout>
  );
};

export default CopenhagenLocation;
